<template>
  <form @submit.prevent="login">
    <error-indicator :error="error" v-if="error"/>
         
    <div class="field">
      <div class="ui left icon input">
        <i class="user icon"></i>
        <input type="text" name="login" placeholder="E-Mail/Benutzername" v-model="username" v-focus>
      </div>
    </div>
    <div class="field">
      <div class="ui left icon input">
        <i class="lock icon"></i>
        <input type="password" name="password" placeholder="Passwort" v-model="password">
      </div>
    </div>

    <div class="ui orange message" v-if="invalid">
      <i class="close icon" @click="invalid = false"/>
      <div class="header">
        Anmeldung fehlgeschlagen
      </div>
      Der Benutzername und/oder Passwort ist falsch.
    </div>

    <router-link to="/recover" class="recover">Passwort vergessen?</router-link>
    <button type="submit" class="ui fluid green submit button">Anmelden</button>
    <loading-indicator v-if="loading"/>
  </form>
</template>

<script>
import LoginMixin from '../mixins/login'
import LoadingIndicator from '~shared/components/loading-indicator.vue'
import ErrorIndicator from '~shared/components/error-indicator.vue'

export default {
  mixins: [LoginMixin],
  components: {
    LoadingIndicator,
    ErrorIndicator
  }
}
</script>

<style>
.recover{
  margin-bottom: 10px;
  display: block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// page.vue?12029fa0